import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AngularFireDatabase } from "@angular/fire/database";
import { FirebaseService } from '../../services/firebase.service';
import { UpdatefirebaseService } from './../../services/updatefirebase.service';
import { ExcelService } from 'src/app/services/excel.service';
import axios from 'axios';
import * as echarts from 'echarts';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-for-test',
  templateUrl: './for-test.component.html',
  styleUrls: ['./for-test.component.css']
})
export class ForTestComponent {
  constructor(
    private spinner: NgxSpinnerService,
    private excelService: ExcelService,
    private firebase: AngularFireDatabase,
    private upfirebase: UpdatefirebaseService) {

  }
  ngOnInit(): void {
    //this.getMap();
    //this.getMapall();
    //this.getmapzone('2324', '01');
    this.test_echarts();
  }


  year = '2425';

  items = [
    {
      loancode: "67-L-13",
      cardcode: "0000029174",
      dscription: "ปุ๋ยอินทรีย์ชนิดผงเทกอง (ผสมโดโลไมท์)",
      quantity: 17.98,
      price: 1550,
      linetotalafvat: 27869
    },
    {
      loancode: "67-L-13",
      cardcode: "0000029174",
      dscription: "ปุ๋ยอินทรีย์ชนิดผงเทกอง (ผสมโดโลไมท์)",
      quantity: 17.26,
      price: 1550,
      linetotalafvat: 26753
    },
    {
      loancode: "67-L-13",
      cardcode: "0000029174",
      dscription: "ปุ๋ยอินทรีย์ชนิดผงเทกอง (ผสมโดโลไมท์)",
      quantity: 17.21,
      price: 1550,
      linetotalafvat: 26675.5
    }
  ];
  onDateChange(e) {
    let date = e.target.value
    console.log('target1', date);
    console.log('target2', this.date2en(date));
  }

  date2en(date: Date): string {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('sv-SE', options);
  }

  filteredItems = [...this.items]; // Copy of the original list

  searchTerm: string = '';

  filterOptions() {
    this.filteredItems = this.items.filter(item =>
      item.dscription.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  exportAsXLSX(data, name): void {
    this.excelService.exportAsExcelFile(data, name);
  }

  test_echarts() {
    let chart = echarts.init(document.getElementById('for_echarts'));
    let option = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: [
            { value: 1048, name: 'Search Engine' },
            { value: 735, name: 'Direct' },
            { value: 580, name: 'Email' },
            { value: 484, name: 'Union Ads' },
            { value: 300, name: 'Video Ads' }
          ]
        }
      ]
    };
    chart.setOption(option);

  }

  data = [];
  getdataCP() {
    this.spinner.show();
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?
    s=top 100 percent [itid],[intlandno],canetype,[groupCode]
    &f=[CPS6263].[dbo].[v_cp6667_basic] cp
    &w=[groupcode]='081309'`
    axios.get(url).then(res => {
      this.spinner.hide();
      if (res.data.length > 0) {
        console.log('data.length', res.data.length);
        console.log('data', res.data);
        this.data = res.data;
      }
    }).catch(err => {
      throw (err)
    })
  }

  getmapAll(year: any) {
    return new Promise((res, rej) => {
      let maps: any = [];
      this.firebase
        .list("inst1/tx/" + year + "/areas")
        .query//.limitToFirst(101)
        .orderByChild("approveSts")
        .equalTo(1)
        .once('value')
        .then(function (snapshot) {
          snapshot.forEach(function (childS) {
            let rec = {
              key: childS.key,
              //...childS.val(),
              //SentDate: childS.val().SentDate || "",
              landno: childS.val().landno || "",
              groupCode: childS.val().groupCode || "",
              //CaneTypeId: childS.val().DetailPlant.CaneTypeId || "",
              groupMt: childS.val().DetailPlant.groupMaintenanceCode || "",
              groupMn: childS.val().DetailPlant.groupMaintenanceName || "",
              /*TargetByPlant: childS.val().DetailPlant.TargetProductByPlant || "",
              approveSts: childS.val().approveSts || "",
              
              CaneTypeName: childS.val().DetailPlant.CaneTypeName || "",
              planPlantDate: childS.val().DetailPlant.planPlantDate || "",
              */
              ZoneId: childS.val().DetailPlant.ZoneId || "",
              //supcode: (childS.val().spv_profile.code) || "",
              //plantDate: childS.val().DetailPlant.plantDate || "",

            }
            if (childS.val().DetailPlant.CaneTypeId != 'OT') {
              maps.push(rec);
              //console.log('reckey : ', childS.key, maps.length);
            }
          });
          //console.log('rec : ', maps.length);
          res(maps)
        }).catch((e) => {
          rej(e)
        })
    })
  }

  getmap_P(year: string, p: string, d1: string, d2: string) {
    let date = [new Date(d1).getTime(), new Date(d2).getTime()]
    return new Promise((res, rej) => {
      let maps: any = [];
      this.firebase
        .list('/inst1/tx/' + year + '/periods', ref =>
          ref.orderByChild(p + '/SentDate')
            .startAt(date[0])
            .endAt(date[1])
        ).snapshotChanges().pipe(
          map(actions =>
            actions.map(a => ({
              key: a.key
              , ...(a.payload.val() as Object)
              //, landno: (a.payload.val().SentDate as Object)
            }))
          )
        ).subscribe(data => {
          res(data);
        }, error => {
          rej(error);
        });
    })
  }

  get_data_p() {
    let d1 = '2024-07-01', d2 = '2024-07-08'
    let p = 'p5'
    this.getmap_P(this.year, p, d1, d2).then((data: any[]) => {
      console.log('Data:', p, data);
    })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  profileA = [];
  async getprofile() {
    try {
      const maps = [];
      await this.firebase
        .list("inst1/profile")
        .query.orderByChild("mrole")
        .startAt(201)
        .endAt(299)
        .once('value')
        .then(function (snapshot) {
          snapshot.forEach(function (childS) {
            const rec = {
              key: childS.key,
              ...childS.val(),
            };
            maps.push(rec);
            //console.log('reckey : ', childS.key, maps.length);
          });
        });
      console.log('recmaps :', maps);
      this.profileA = maps;
    } catch (error) {
      throw error;
    }
  }

  getmapbykey(key = '') {
    return new Promise((res, rej) => {
      let maps: any = [];
      this.firebase
        .list(`inst1/tx/${this.year}/areas`)
        .query.orderByKey()
        .equalTo(key)
        .once("value")
        .then(function (snapshot) {
          snapshot.forEach(function (childS) {
            let rec = {
              key: childS.key,
              ...childS.val(),
            }
            maps.push(rec);
          });
          //console.log('rec : ', maps.length);
          res(maps)
        }).catch((e) => {
          rej(e)
        })
    })
  }

  dataKey = [];
  itid = '';
  loadkey() {
    let key = this.itid;
    this.getmapbykey(key).then((maps: any) => {
      this.spinner.hide();
      if (maps.length > 0) {
        //console.log('key.length', maps.length);        
        this.dataKey = maps;
        console.log('key:', maps);
      }
      else {
        alert('key:' + key + 'ข้อมูลที่เลือกไม่พบข้อมูล');
      }
    });
  }

  async getmapby1() {
    try {
      const maps = [];
      const snapshot = await this.firebase
        .list("inst1/tx/2324/areas", (ref) =>
          ref.orderByChild("DetailPlant").equalTo(true)
        )
        .query.once("value");

      snapshot.forEach((childS) => {
        const rec = {
          key: childS.key,
          ...childS.val(),
        };
        maps.push(rec);
        //console.log('reckey : ', childS.key, maps.length);
      });
      return maps;
    } catch (error) {
      throw error;
    }
  }

  loadgetmapby1() {
    this.spinner.show();
    this.getmapby1().then((maps: any) => {
      this.spinner.hide();
      if (maps.length > 0) {
        console.log('key.length', maps.length);
        console.log('keyby1:', maps);
      }
      else {
        alert('key:' + 'ข้อมูลที่เลือกไม่พบข้อมูล');
      }
    });
  }

  async getmapby2() {
    try {
      const snapshot = await this.firebase
        .list("inst1/tx/2324/areas", (ref) =>
          ref.orderByChild("approveSts").equalTo(3)
        )
        .query.once("value");
      const maps = [];
      snapshot.forEach((childS) => {
        const rec = {
          key: childS.key,
          ...childS.val(),
        };
        maps.push(rec);
      });
      return maps;
    } catch (error) {
      throw error;
    }
  }

  async getmap_str_cut(year: string) {
    try {
      const snapshot = await this.firebase
        .list(`inst1/tx/${year}/areas`, (ref) =>
          ref.orderByChild("approveSts").equalTo(1)
        )
        .query.once("value");
      const maps = [];
      snapshot.forEach((childS) => {
        const rec = {
          key: childS.key,
          //...childS.val(),
          landno: childS.val().landno || "",
          groupCode: childS.val().groupCode || "",
          cutstatus: childS.val().DetailPlant.cutstatus || "",
          cutstart: childS.val().DetailPlant.cutstart || "",
          cutstop: childS.val().DetailPlant.cutstop || "",
          cutstill: childS.val().DetailPlant.cutstill || "",
          dateupdate: childS.val().DetailPlant.dateupdate || "",
        };
        if ((childS.val().DetailPlant.cutstatus || "").toString().length > 0) {
          maps.push(rec);
        }

      });
      return maps;
    } catch (error) {
      throw error;
    }
  }

  maps_cut = []
  getMap_cut() {
    let year = '2425';
    this.spinner.show();
    //--
    this.getmap_str_cut(year).then((maps: any) => {
      this.spinner.hide();
      if (maps.length > 0) {
        console.log('getmap_str_cut.length', maps);
        console.log('getmap_str_cut', maps);

        this.maps_cut = maps//.filter((el: any) => (el.cutstatus.length > 0));
        //console.log('getmap_str_cut.length', this.maps_cut);
        //console.log('getmap_str_cut', this.maps_cut);
        //console.log('maps', maps);
      }
      else {
        alert('ข้อมูลที่เลือกไม่พบข้อมูล');
      }
    });
  }

  updatecut_firebae() {
    let data = this.maps_cut;
    if (confirm(`ต้องการบันทึกข้อมูล แปลง จำนวน ${data.length} หรือไม่?`)) {
      this.spinner.show();
      for (let i = 0; i < data.length; i++) {
        let url: string, ar0 = data[i]
        console.log(i, ', .key:', ar0.key, ', แปลง:', ar0.landno);

        //this.updatefirebase.updateCutStartBySupport(ar0.itid, this.year_id, datestart, datestop);          
        this.upfirebase.updateareas('2324', ar0.key + "/DetailPlant",
          {
            cutstart: "",
            cutstop: "",
            cutstatus: "",
            cutstill: "",
            dateupdate: "",
          }
        );
      }
      this.spinner.hide();
      alert("อัพเดทวันตัดแล้วค่ะ");
    }
  }


  maps = []
  getMapall() {
    let year = this.year;
    this.spinner.show();
    //--
    this.getmapAll(year).then((maps: any) => {
      this.spinner.hide();
      if (maps.length > 0) {
        console.log('maps.length', maps.length);
        this.maps = maps;
        console.log('maps:', maps);
      }
      else {
        alert('ข้อมูลที่เลือกไม่พบข้อมูล');
      }
    });
  }

  have = [];
  noHave = [];
  onHave = [];
  cnt_update = 0;
  percent = 0;
  updatefirebase() {
    let have = 0;
    let noHave = 0;
    if (confirm("ต้องการแก้ไขข้อมูล")) {
      let year = this.year;
      let maps = this.maps;
      let data = this.data;
      data.forEach(async (item, index) => {
        //console.log("progress");
        let findMap = maps.find((x) => x.key == item.itid);
        if (findMap) {
          have++;
          this.percent = ((index + 1) / data.length) * 100;
          let key = findMap.key;
          //if (findMap.groupCode != "081305") {
          //if (findMap.groupMt != item.groupCode_m) {
          //console.log("have:", item, "- findMap:", findMap.groupMt);
          this.cnt_update++;
          /*this.upfirebase.updateareas(year, key,
            {
              //groupCode: item.groupCode
              groupCode: "081305"
            }
          );*/
          this.upfirebase.updateareas(year, key + "/DetailPlant",
            { groupCode: item.groupCode }
          );
          //}
          await new Promise(resolve => setTimeout(resolve, 500));
        } else {
          noHave++;
          //console.log("nohave", item);
          this.noHave.push(item);
        }
      });
      console.log("nohave", this.noHave);
      console.log("cnt_update", this.cnt_update);
      console.log("have", this.onHave);
    }
  }


  upfirebase2() {
    let key = '', slach = '', val
    let year = this.year
    this.getmapbykey(key).then((maps: any) => {
      if (maps.length > 0) {
        //console.log('key.length', maps.length);        
        //data = maps;
        console.log('key:', maps);
        this.upfirebase.updateareas(year, key + slach, val);
      }
    });
  }

  async edit_sup_data() {
    let have = 0, haveSpv = 0, noSpv = 0, noHave = 0;
    let data = this.Edata;
    let l = data.length
    let updated = 0;
    if (l > 0) {
      if (confirm(`ต้องการแก้ไขข้อมูล นสส จำนวน ${data.length} `)) {
        //console.log('key.length', maps.length);
        console.log('key:', data);
        //data.forEach(async (item, index) => {
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          //console.log("progress");
          let findSpv = this.profileA.find((x) => x.code == item.code);
          if (findSpv) {
            haveSpv += 1;
            let spv = findSpv.key;
            let spv_profile = { code: item.code, name: findSpv.name, pName: "", surname: findSpv.surname, };
            /*let findMap = this.maps.find((x) => x.key == item.itid);
            if (findMap) {*/
            this.getmapbykey(item.itid).then((maps: any) => {
              this.percent = 0;
              let percent: number;
              if (maps.length > 0) {
                have += 1;
                let key = item.itid;
                let date = new Date().toLocaleString('th-TH', { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" });
                if (item.code != maps.code) {
                  updated += 1
                  this.upfirebase.updateareas(this.year, key,
                    {
                      spv: spv,
                      spv_profile: spv_profile,
                      //landno: item.landno
                    }
                  );
                  /*this.upfirebase.updateareas(this.year, key + "/DetailPlant",
                    { //ZoneId: item.zone, 
                      groupMaintenanceCode: "",
                      groupMaintenanceName: "",
                    }
                  );*/
                  percent = ((i + 1) / l) * 100;
                  this.percent = percent;
                  console.log((i + 1), percent.toLocaleString(), 'update_:', this.year, "key:", key, date, ", spv_profile:", spv_profile);
                }
                else { console.log((i + 1), percent.toLocaleString() + '%', 'no_update_ ', this.year, "key:", key, date, ", spv_profile:", spv_profile); }
              }
              else {
                noHave += 1;
                console.log("noHave", item.itid);
              }
            });
          }
          else { noSpv += 1; console.log("noSpv", findSpv.key); }
          await new Promise(resolve => setTimeout(resolve, 500));
        }//);
      }
      console.log("have", have);
      console.log("noHave", noHave);
      console.log("updated", updated);
    }
  }

  num_se = { start: 0, end: 0, now: 0 }
  async edit_data() {
    let have = 0, haveSpv = 0, noSpv = 0, noHave = 0;
    //let data = this.Edata2;
    let data = this.Edata3;

    let updated = 0;
    this.num_se.start = 0;
    this.num_se.end = data.length;

    if (data.length > 0) {
      //if (confirm(`ต้องการแก้ไขข้อมูล เป็น SR จำนวน ${data.length} `)) {
      if (confirm(`ต้องการแก้ไขข้อมูล พื้นฐาน จำนวน ${data.length} `)) {

        //console.log('key.length', maps.length);
        //console.log('key:', data);
        let percent = 0;
        //data.forEach(async (item, index) => {
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          //console.log("progress");          
          /*let findMap = this.maps.find((x) => x.key == item.itid);
          if (findMap) {*/
          let date = new Date().toLocaleString('th-TH', { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "numeric" });
          this.getmapbykey(item.itid).then((maps: any) => {
            if (maps.length > 0) {
              have += 1;
              let key = item.itid;
              updated += 1
              this.upfirebase.updateareas(this.year, key + "/DetailPlant",
                {
                  //ZoneId: item.zone,
                  //groupMaintenanceCode: item.gcode,
                  //groupMaintenanceName: item.gname,
                  //CaneTypeId: item.typecode,
                  //CaneTypeName: item.typename
                  /*SelfLand: item.SelfLand,
                  TargetProductByPlant: item.TargetProductByPlant,
                  levelOfTheArea: item.levelOfTheArea,*/
                  Suggestion: '-'
                }
              );
              /*this.upfirebase.updateareas(this.year, key,
                { //spv: spv,
                  //spv_profile: spv_profile,
                  //landno: item.landno
                  cutstart: item.start,
                  cutstop: item.stop
                }
              );*/
              percent = ((i + 1) / data.length) * 100;
              this.percent = percent;
              this.num_se.now = i;
              console.log(i + 1, "Update ", percent.toLocaleString(), this.year, item, ", data:", date,);
            }
            else {
              noHave += 1;
              console.log(i + 1, "xUpdate ", percent.toLocaleString(), this.year, item, ", data:", date,);
            }
          });
          await new Promise(resolve => setTimeout(resolve, 500));
        }

      }//);
    }
    console.log("have", have);
    console.log("noHave", noHave);
    console.log("updated", updated);
  }

  async edit_data2() {
    let have = 0;
    let noHave = 0;
    let updated = 0;
    let data = this.Edata2
    //let data = this.Edata3

    if (data.length > 0) {
      if (confirm(`ต้องการแก้ไขข้อมูล supcode Edata2 จำนวน ${data.length} `)) {
        let year = this.year;
        let maps = this.maps;
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          let findMap = maps.find((x) => x.key == item.itid);
          //let findMap = maps.filter(el => el.key == item.itid);
          let date = new Date().toLocaleString('th-TH', { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "numeric" });
          //console.log("findMap:", findMap);          
          if (findMap) {
            let findSpv = this.profileA.find((x) => x.code == item.code);
            let key = findMap.key
            let spv = findSpv.key;
            let spv_profile = { code: item.code, name: findSpv.name, pName: "", surname: findSpv.surname, };
            have++;
            this.percent = ((i + 1) / data.length) * 100;
            if (findSpv /*findMap.landno!= item.landno*/) {
              have += 1;
              updated += 1
              this.upfirebase.updateareas(this.year, key + "/DetailPlant",
                { //ZoneId: item.zone, 
                  /*groupMaintenanceCode: item.gcode,
                  groupMaintenanceName: item.gname,*/
                  Suggestion: '-'
                }
              );
              /*this.upfirebase.updateareas(this.year, key, {
                spv: spv,
                spv_profile: spv_profile,
                //landno: item.landno
              });*/
              console.log(i + 1, ", ", this.year, ', ', item, ", data:", date, spv_profile);
              await new Promise(resolve => setTimeout(resolve, 500));
            }
          } else {
            noHave++;
            console.log("nohave", item);
            this.noHave.push(item);
          }
        }
        console.log("nohave", this.noHave);
        console.log("cnt_update", this.cnt_update);
        console.log("have", this.onHave);
      }
    }
  }


  Edata = [

    { itid: "-NxQoqt-_gdSRPN9K5ve", zone: "", code: "091" },
    { itid: "-NxQWg8ANPA7pH-3nuKz", zone: "", code: "091" },
    { itid: "-NxQZRH5qiT1TdKkvK6n", zone: "", code: "091" },
    { itid: "-NxRBEG1lcoZUj_1OLBK", zone: "", code: "091" },
    { itid: "-NyhnX7Cjy1PMfPzN-q4", zone: "", code: "091" },
    { itid: "-NyhoRMnxGBbGhSmG1GC", zone: "", code: "091" },
    { itid: "-O0I268ELjAYD9z4Rs09", zone: "", code: "091" },
    { itid: "-O2O50m2BLG8vc1HiavM", zone: "", code: "091" },

  ]
  Edata2 = [

    { itid: "-Noyk_6eBaxzYUuwnXT6", code: "", typecode: "SR", typename: "ต้นฝน" },
    { itid: "-NkEDNawfMJooX7K34J-", code: "", typecode: "SR", typename: "ต้นฝน" },
    { itid: "-NjgnkHrFa_Lllwshx9p", code: "", typecode: "SR", typename: "ต้นฝน" },
    { itid: "-NkDd0kBmYhRuQOVt8bZ", code: "", typecode: "SR", typename: "ต้นฝน" },
    { itid: "-NjWE5VVk_WdYXcGdUPg", code: "", typecode: "SR", typename: "ต้นฝน" },
    /*
{ itid: "-NiVABJfcn4g2DU7-u8N", code: "", typecode: "SR", typename: "ต้นฝน" },
{ itid: "-Nq1bWX6dMbHyzKlzkfO", code: "", typecode: "SR", typename: "ต้นฝน" },
*/
    /* 
     { itid: "-NHwvFgfhr6DN1Zb-Ucx", code: "", start: "2024-04-01", stop: "2024-04-20" },
     { itid: "-NJJVbfUsazyTjkm0asX", code: "", start: "2024-04-01", stop: "2024-04-20" },
     */
  ];
  Edata3 = [
    { itid: "-OAvWjEEah_h5kkdFIco" },
    { itid: "-OAvZ2BZ4zAvLIGz6Tip" },
    { itid: "-OB0AcpSeJXzzG_HGkmp" },
    { itid: "-OB0C_F1l1EUiawLPf1y" },
    { itid: "-OB3kXzsd3DPa3DRuIAb" },
    { itid: "-OB3mei8bV5ZlblcVGH1" },
    { itid: "-OB43eFi41H_7ks-FOAV" },
    { itid: "-OB49TH0YVLN8p1fxvbt" },
    { itid: "-OB9D-BCg6SWPw7s6Jpe" },
    { itid: "-OB9GCN_xhAhg1bXeWcE" },
    { itid: "-OBAKPSmeWVz03KiCZIx" },
    { itid: "-OBc_Da6vmRkdOrzZskL" },
    { itid: "-OBcYwnw-x3SxiWAY2J0" },
    { itid: "-OBDFqhsLWJ2hiBGC-WL" },
    { itid: "-OBdgzgmRJVuDYlng-jc" },
    { itid: "-OBGE2S6OOgREw68JGTf" },
    { itid: "-OBhByejQuNY2yXuNM0z" },
    { itid: "-OB-hx1bXa9bGj3_FbEC" },
    { itid: "-OBikCSpI7_F6CNFRUjp" },
    { itid: "-OBInvK6VRPX-9JOmNPV" },
    { itid: "-OBOXW5ik3HEHJickN4Y" },
    { itid: "-OBOYCmD2idGf6H-L6u0" },
    { itid: "-OB-p2DxOfoUdO2IqasC" },
    { itid: "-OBPRFY1fAP8rOTFDUJJ" },
    { itid: "-OBTVm2BG3uQ3vpzHqa9" },
    { itid: "-OBUPpTn9xA8j2WS_IIf" },
    { itid: "-OBYwayzOAFjiA3ruBdA" },
    { itid: "-OBZBHrHPiRCyTnhjdVs" },
    { itid: "-OBZMP0Azqvo5UZ8meiu" },
    { itid: "-OC1DAaxQeMA0GUjvm7y" },
    { itid: "-OC1EIRzuhLHAGDzROF-" },
    { itid: "-OC1F5Sw5bcchY4KYAmd" },
    { itid: "-OC1FxNLj1IuIj1BIz8G" },
    { itid: "-OC1GpqnNNaFqVwpPIjY" },
    { itid: "-OCCfY6lmdI5K-cCCan7" },
    { itid: "-OCChkQmUCHDVcXfFLFe" },
    { itid: "-OCClnW1J2WIwV84KF_0" },
    { itid: "-OCHYkixiZz4horg5ka-" },
  ]
}
